import { getRequest, postRequest } from 'config/Axios/baseConfig';
import { portfolioDrugInterface } from 'Interfaces/FactsInterfaces/DrugPortfolioInterface';

export const drugPortfolioservices = {
  getportfolioDrugs: (type: string): Promise<portfolioDrugInterface[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<portfolioDrugInterface[]>(
          `facts/get-portfolio-status/${type}`
        );
        resolve(data);
      } catch (error) {
        console.log('in drugPortfolioservices > getportfolioDrugs, Err===> ', error);
        reject(error);
      }
    });
  },

  updateDrugPortfolioStatus: (payload: {
    ndc11: string;
    source: string;
    destination: string;
    last_modified_by: string;
    note: string;
  }): Promise<string> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<{ message: string }>(
          `facts/update-portfolio-drug-status`,
          payload
        );
        resolve(data.message);
      } catch (error) {
        console.log('in drugPortfolioservices > getportfolioDrugs, Err===> ', error);
        reject(error);
      }
    });
  },

  bulkUpdateDrugPortfolioStatus: (payload: {
    component_ids: number[];
    source: string;
    destination: string;
    note: string;
  }): Promise<{
    message: string;
    created_components: {
      ComponentID: number;
      NDC11: string;
      ReportingSegmentID: { ReportingSegmentID: number; ReportingSegmentName: string };
      StartDate: string;
      EndDate: string;
    }[];
  }> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<{
          message: string;
          created_components: {
            ComponentID: number;
            NDC11: string;
            ReportingSegmentID: { ReportingSegmentID: number; ReportingSegmentName: string };
            StartDate: string;
            EndDate: string;
          }[];
        }>(`facts/bulk-update-portfolio-drug-status`, payload);
        resolve(data);
      } catch (error) {
        console.log('in drugPortfolioservices > bulkUpdateDrugPortfolioStatus, Err===> ', error);
        reject(error);
      }
    });
  },
};
